module.exports = __webpack_public_path__ + "img/bottom.25ada779.webp";